export default "__VITE_ASSET__B0DsgA4T__"